export default "__VITE_ASSET__Cc$Rnttu__"